<template>
  <mdb-row>
    <mdb-col md="6">
      <mdb-select
        search
        @getValue="loadAdvert"
        v-if="loadReady"
        v-model="labelAdverts"
        :visibleOptions="6"
        :label="$t('advertisement')"
        :placeholder="$t('choose_advertisement')"
      />
    </mdb-col>
    <mdb-col md="6">
      <mdb-select
        @getValue="getSelectValue"
        v-if="loadReady"
        v-model="labelBenefits"
        :visibleOptions="6"
        :label="$t('benefit')"
        :placeholder="$t('choose_benefit')"
      />
    </mdb-col>
  </mdb-row>
</template>

<script>
import { mdbSelect, mdbCol, mdbRow } from "mdbvue";

export default {
  name: "AdvertisementBenefitSelection",
  components: {
    mdbSelect,
    mdbCol,
    mdbRow,
  },
  props: {
    content: Object,
  },
  data: () => ({
    loadReady: false,
    benefitId: 0,
    advertisementId: 0,
    adswithbenefits: [],
    labelAdverts: [],
    labelBenefits: [],
    advertbenefitpath: "/1.0/front/benefitcodes/advertisements-with-benefits",
  }),
  methods: {
    checkContent() {
      this.advertisementId =
        this.content != null && this.content.advertisement.id != 0
          ? this.content.advertisement.id
          : this.adswithbenefits[0].id;
          
      this.adswithbenefits.forEach(function (advertisement) {
        this.labelAdverts.push({
          text: advertisement.title + ", id:" + advertisement.id,
          value: advertisement.id,
          selected: advertisement.id === this.advertisementId ? true : false,
        });
      }, this);

      this.updateBenefits(this.advertisementId);
    },
    updateBenefits(advertisementId) {
      const advert = this.adswithbenefits.find((a) => a.id === advertisementId);
      if (!advert || !advert.benefits || advert.benefits.length === 0) return;

      this.benefitId =
        this.content != null && this.content.benefit.id != 0
          ? this.content.benefit.id
          : advert.benefits[0].id;

      /*this.labelBenefits = advert.benefits.map((benefit) => ({
        text: benefit.title + ", id:" + benefit.id,
        value: benefit.id,
        selected: benefit.id === this.benefitId,
      }));*/

      advert.benefits.forEach(function (benefit) {
        this.labelBenefits.push({
          text: benefit.title + ", id:" + benefit.id,
          value: benefit.id,
          selected: benefit.id === this.benefitId ? true : false,
        });
      }, this);
    },
    loadAdvert(val) {
      this.advertisementId = val;
      this.updateBenefits(val);
      this.$emit("advertbenefits", this.advertisementId, this.benefitId);
    },
    getSelectValue(val) {
      this.benefitId = val;
      this.$emit("advertbenefits", this.advertisementId, this.benefitId);
    },
  },
  watch: {
    content: function (newVal, oldVal) {
      if (newVal !== null) {
        this.checkContent();
      }
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
    },
  },
  mounted() {
    this.$http
      .get(this.advertbenefitpath)
      .then((response) => {
        if (response.status == 200) {
          this.adswithbenefits = response.data.adswithbenefits;
          this.checkContent();
          this.$emit("advertbenefits", this.advertisementId, this.benefitId);
          this.loadReady = true;
        } else if (response.status == 401) {
          this.$root.$emit("session_failed");
        }
      })
      .catch((error) => {
        window.__logAxiosErrorIfDebug(error, {
          context: "RetailerChainSelection.vue - mounted",
        });
        this.$root.$emit("session_failed");
        return error;
      });
  },
};
</script>

<style>
.form-control {
  color: #495057;
}
</style>
